import { Box, Heading, Text, SimpleGrid, Container } from "@chakra-ui/react"

export default function AboutUs() {
    const features = [
        {
            title: "SHANNON'S CHOSEN DETAILER FOR 23 YEARS",
            description:
                "Shannon's have used CHROMA for over 23 years and we are very proud of that association, we have detailed some of the rarest cars in the country, not to mention the recent sympathetic detail of the ultra-rare 1926 Bugatti Type 37 race car.",
        },
        {
            title: "WE DON'T OUTSOURCE",
            description:
                "There is only one person here, Chris Harris, and he is old school, takes pride and will not allow your car to be touched by anyone but him, this is how we roll.",
        },
        {
            title: "OVER 30 YEARS EXPERIENCE",
            description:
                "Very few detailers can boast these numbers, let alone being entrusted to work on. an incredible array of priceless vehicles, fun fact, Chris has worked on over half a billion dollars worth of car value over his career, and other fun fact, Chris has detailed the late Michael Hutchinson's Harley Davidson back in the early days.",
        },
        {
            title: "INDIVIDUAL TREATMENT",
            description:
                "At Chroma Detailing each car is treated individually. Not only is the treatment personalised to get the best results out of your car, but one car is treated at any one time ensuring Chris' full attention.",
        },
    ]

    return (
        <Box bg="#F3F4F6" py={{ base: 10, md: 20 }} id="aboutus">
            <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
                <Heading size="5xl" textAlign="center" fontWeight="medium" mb={2}>
                    About Us
                </Heading>
                <Text textAlign="center" fontSize="1xl" mb={10}>
                    Why trust CHROMA with your special car?
                </Text>
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>
                    {features.map((feature, index) => (
                        <Box
                            key={index}
                            bg="white"
                            p={6}
                            mx={6}
                            mb={10}
                            borderRadius="lg"
                            boxShadow="md"
                            borderBottom="3px solid #131416"
                            _hover={{ boxShadow: "xl", transform: "translateY(-4px)", transition: "0.3s ease-in-out" }}
                        >
                            <Heading as="h2" fontWeight="semibold" mb={3}>
                                {feature.title}
                            </Heading>
                            <Text fontSize="md" color="gray.700">
                                {feature.description}
                            </Text>
                        </Box>
                    ))}
                </SimpleGrid>
            </Container>
        </Box>
    )
}
